module.exports = __webpack_public_path__ + "img/alert-circle.ed3f156e.svg";